/* eslint-disable require-atomic-updates */
import { Cookie as CookieNames, FeatureFlag } from '@ps/web-core-enums';
import { LoginSource } from '@ps/web-core-store';
import * as Sentry from '@sentry/react';
import Cookies from 'universal-cookie';

import type { EffectParams } from '@swf/core/store';
import { getState, select } from '@swf/core/store';

import { loginSuccess } from './utils';

const cookies = new Cookies();

export const fetchJWT = async (
  payload: { token: string; signature: string; webId: string } | undefined,
  request: EffectParams['request']
) => {
  const { token, signature, webId } = payload || {};
  if (token && signature && webId) {
    const domain = select.location.getCookieDomain(getState());
    cookies.set(CookieNames.TOKEN, token, { domain, path: '/', encode: (value) => value });
    cookies.set(CookieNames.SIGNATURE, signature, { domain, path: '/', encode: (value) => value });
    cookies.set(CookieNames.WEB_ID, webId, { domain, path: '/', encode: (value) => value });
    const { body } = await request<{ token: string }>({
      service: '/api/v1-preview/auth/session',
      http: true
    });
    return body.token;
  }
};

const verifySession = async (
  payload: undefined,
  { dispatch, request, rootState }: EffectParams
) => {
  const isEmbedded = select.device.isEmbedded(rootState);
  const loginSource = LoginSource.VerifySession;
  const isIdpSecondaryLoginEnabled = select.feature.check(
    rootState,
    FeatureFlag.IdpSecondaryLoginEnabled
  );

  try {
    const token = isEmbedded
      ? await fetchJWT(window?.starsweb?.auth, request)
      : select.session.get(rootState).token;

    if (!token) {
      return dispatch.session.update({ authSource: 'client', serverAuth: false });
    }

    await loginSuccess({ token, loginSource }, { dispatch, request });
    if (isIdpSecondaryLoginEnabled) {
      await dispatch.auth.idpLoginSuccess({ loginSource: LoginSource.VerifySession });
    }
  } catch (error) {
    Sentry.addBreadcrumb({
      type: 'debug',
      category: 'session-error',
      message: (error as Error)?.message,
      data: error || {}
    });
    dispatch.auth.logout({ implicit: true });
    window?.starsweb?.auth.login();
  }
};

export default verifySession;
